import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import AppErrorBoundary from './AppErrorBoundary.jsx';
import {LanguageProvider} from './i18n/LanguageProvider.jsx';
import './studio-v2.css';
import './brand-theme.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LanguageProvider><AppErrorBoundary><App /></AppErrorBoundary></LanguageProvider>
  </React.StrictMode>,
);
